<template>
  <div class="leaderboard">

    <div class="leaderboard__wrapper">

      <div class="leaderboard__title">
        <h2>Rezultati</h2>
        <p>Prikaži rezultate u kategoriji:</p>
        <div class="leaderboard__results-filter">

          <a
            href="#"
            class="leaderboard__results-button"
            :class="{ 'leaderboard__results-button--active': filter === 'all' }"
            @click.prevent="changeCategory('all')"
          >svi</a>

          <a
            href="#"
            class="leaderboard__results-button"
            :class="{ 'leaderboard__results-button--active': filter === 'student' }"
            @click.prevent="changeCategory('student')"
          >studenti</a>

          <a
            href="#"
            class="leaderboard__results-button"
            :class="{ 'leaderboard__results-button--active': filter === 'pupil' }"
            @click.prevent="changeCategory('pupil')"
          >učenici</a>

          <a
            href="#"
            class="leaderboard__results-button"
            :class="{ 'leaderboard__results-button--active': filter === 'other' }"
            @click.prevent="changeCategory('other')"
          >ostali</a>
        </div>
      </div>
      <div class="leaderboard__results">

        <table class="leaderboard__results-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Alias</th>
              <th>&uarr; Rezultat</th>
              <th v-if="filter === 'all'">Kategorija</th>
              <!-- <th>&darr; Datum</th> -->
            </tr>
          </thead>
          <tbody v-if="results.length > 0">
            <tr v-for="(result, index) of results">
              <td width="5%">{{ index + 1 }}</td>
              <td width="45%">{{ result.alias }}</td>
              <td width="25%">{{ result.result }}</td>
              <td v-if="filter === 'all'">{{ filterNames[result.category] }}</td>
              <!-- <td :title="parseTime(result.time, true)">{{ parseTime(result.time, false) }}</td> -->
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4">Za sad nema prijavljenih</td>
            </tr>
          </tbody>
        </table>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
import countdown from '@/components/countdown.min.js'
import axios from 'axios'
import moment from 'moment'
axios.defaults.headers.common['Authorization'] = Date.now()
const apiUrl = `https://api.suncobraniranje.phishar.com/submissions`
export default {
  data() {
    return {
      submissions: [],
      filter: 'student',
      until: false,
      filterNames: {
        student: 'studenti',
        pupil: 'učenici',
        other: 'ostali'
      }
    }
  },
  computed: {
    results() {
      let data = []
      for (let entry of this.submissions) {

        if (entry.status === this.filter || this.filter === 'all') {
          data.push({
            alias: entry.alias,
            result: parseFloat(entry.result.trim()),
            time: entry.time,
            category: entry.status
          })
        }

      }

      let aliases = []
      let final = []
      let sorted = data.sort((a, b) => a.result - b.result)
      for (let index in sorted) {
        if (aliases.indexOf(sorted[index].alias) === -1) {
          final.push(sorted[index])
          aliases.push(sorted[index].alias)
        }
      }
      return final
    },
    resultsByTime() {
      let data = []
      for (let entry of this.submissions) {

        if (entry.status === this.filter || this.filter === 'all') {
          data.push({
            alias: entry.alias,
            result: 'sakriven',
            time: entry.time,
            category: entry.status
          })
        }

      }

      let aliases = []
      let final = []
      let sorted = data.sort((a, b) => b.time - a.time)
      for (let index in sorted) {
        if (aliases.indexOf(sorted[index].alias) === -1) {
          final.push(sorted[index])
          aliases.push(sorted[index].alias)
        }
      }
      return final
    }
  },
  methods: {
    parseTime(time, long) {
      return long ? moment(time).format('DD.MM.YYYY. HH:mm:ss') : moment(time).format('DD.MM. u HH:mm')
    },
    changeCategory(category) {
      this.filter = category
    },
    updateTimer() {
      const data = countdown(new Date(2021, 10, 6, 11, 0)).toString()
      // gle, don't judge, pod kojim pritiskom je radeno...
      this.until = data
        .replace('and', 'i')
        .replace('days', 'dana')
        .replace('day', 'dan')
        .replace('hours', 'sati')
        .replace('hour', 'sat')
        .replace('minutes', 'minuta')
        .replace('minute', 'minuta')
        .replace('seconds', 'sekundi')
        .replace('second', 'sekunda')

      setTimeout(() => {
        this.updateTimer()
      }, 1000)
    }
  },
  mounted() {
    axios
    .get(apiUrl)
    .then(({ data }) => {
      this.submissions = data.results
    })
    .catch(error => {
      console.error('Error', error)
    })

    this.updateTimer()
  }
}
</script>
